import styled from 'styled-components'

import theme, { ScreenBreakpoints } from '../../theme'

const StyledHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overflow-y: visible;
  z-index: 1;

  &.low {
    height: 56px;
    flex: 0 1 56px;
  }

  &.high {
    height: 72px;
    flex: 0 1 72px;
  }

  &.dark {
    background-color: ${theme.colors.gray10};
    color: ${theme.colors.white};
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  }

  &.light {
    background-color: ${theme.colors.headerBackground};
    color: ${theme.colors.black};
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.04);
  }

  &.blue {
    background-color: ${theme.colors.blueBackground};
    color: ${theme.colors.white};
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.04);
  }

  .main {
    width: 100%;
    height: 100%;
    display: flex;

    @media (max-width: ${ScreenBreakpoints.large}px) {
      margin: 0 32px;
    }

    @media (min-width: ${ScreenBreakpoints.large + 1}px) and (max-width: ${ScreenBreakpoints.extraLarge}px) {
      margin: 0 48px;
    }

    @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
      margin: 0 80px;
    }

    @media (max-width: ${ScreenBreakpoints.medium}px) {
      margin: 0 24px;
    }
  }

  .fixedWidth {
    @media (max-width: ${ScreenBreakpoints.large}px) {
      max-width: 694px;
      margin: 0 32px;
    }

    @media (min-width: ${ScreenBreakpoints.large + 1}px) and (max-width: ${ScreenBreakpoints.extraLarge}px) {
      max-width: 784px;
      margin: 0 30px;
    }

    @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
      max-width: 1140px;
      margin: 0 30px;
    }
  }

  .staticWidth {
    margin: 0 16px;
  }
`

export { StyledHeader }
